<div class="container">
  <div class="row m-2">
    <mat-form-field appearance="outline" class="col-4">
      <mat-label>Select User Name</mat-label>
      <mat-select [(ngModel)]="selectedUserName">
        <mat-option *ngFor="let u of UserName$" [value]="u">{{ u }}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" class="col-4">
      <mat-label>Select Department</mat-label>
      <mat-select [(ngModel)]="selectedDepartments">
        <mat-option *ngFor="let d of departments$|async" [value]="d">{{d}}</mat-option>
      </mat-select>
    </mat-form-field>

    <div class="col-3">
      &nbsp;&nbsp;<button mat-mini-fab color="accent" matTooltip="Search" (click)="Search()">
      <mat-icon>search</mat-icon>
    </button>&nbsp;&nbsp;&nbsp;&nbsp;
      &nbsp;&nbsp;&nbsp;&nbsp;
      <button mat-mini-fab color="accent" (click)="clearAll()" matTooltip="Clear">
        <mat-icon>clear</mat-icon>
      </button>
    </div>
  </div>
  <div class="card p-2">
    <div class="ngxTableHeader">
      <ul class="header-buttons-left ms-0 mb-0">
        <li class="dropdown">
          <h2>Users</h2>
        </li>
        <li class="dropdown m-l-20">
          <label for="search-input"><i class="material-icons search-icon">search</i></label>
          <input placeholder="Search" type="text" class="browser-default search-field"
                 (keyup)='applyFilter($event)' aria-label="Search box" #input>
        </li>
      </ul>
      <ul class="header-buttons mr-2">
        <li>
          <button mat-mini-fab color="primary" permission="Users" [permissionTypes]="[PermissionType.ALL, PermissionType.ADD]">
            <mat-icon class="col-white" (click)="openpopup()" >add</mat-icon>
          </button>
        </li>

      </ul>
    </div>
    <div class="row clearfix">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <div class="card">
          <div class="body">
            <div class="row">
              <div class="col-3" *ngFor="let element of pagedFilteredData;let i = index">
                <div class="card border-apply">
                  <div class="m-b-20">
                    <div class="contact-grid w-100">
                      <div class="profile-header" [ngClass]="cardColors[i % cardColors.length]">
                        <div class="user-name">{{ element?.userName }}</div>
                        <div class="name-center">{{ element?.jobtitle }}</div>
                      </div>
<!--                      <img-->
<!--                        [src]="element?.profileImages?.length ? element.profileImages[0] : 'assets/images/userbig.png'"-->
<!--                        (error)="onImageError($event)"-->
<!--                        alt=""-->
<!--                        class="user-img">-->
                      <div class="profile-container position-relative">
                        <img
                          [src]="element?.profileImages ?? 'assets/images/userbig.png'"
                          (error)="onImageError($event)"
                          alt="Profile"
                          class="user-img">
                        <!-- Hidden file input -->
                        <input type="file" #fileInput accept="image/*" style="display: none" (change)="onFileChange($event,element?.id)" />
                        <!-- Button to trigger file input -->
                        <button mat-mini-fab color="accent" class="edit-icon" matTooltip="Add Profile Image" (click)="fileInput.click()">
                          <mat-icon>edit</mat-icon>
                        </button>
                      </div>

                      <div [ngClass]="{
                      'text-success': getStatus(element) === 'Active',
                      'text-danger': getStatus(element) === 'Inactive'}">
                        <strong>{{ getStatus(element) }}</strong>
                      </div>
                      <div class="text-center m-1">
                        <p class="mb-0">
                           {{ element?.location }}
                        </p>
                        <p class="mb-0">
                          {{ element?.email }}
                        </p>
                        <p class="mb-0">
                           {{ element?.mobile }}
                        </p>
                      </div>

                      <!--                      <div class="w-100">-->
<!--                        <p class="truncate-text mb-0">{{ element?.location }}</p>-->
<!--                      </div>-->
<!--                      <div><span class="phone m-0"><i class="material-icons">phone</i>{{ element?.mobile }}</span></div>-->
                      <div class="profile-userbuttons justify-content-center d-flex gap-2">
                        <button mat-raised-button  (click)="viewDialog(element)" matTooltip="Edit Permissions" permission="Users" [permissionTypes]="[PermissionType.ALL, PermissionType.EDIT]"><span style="color: dodgerblue">Edit Permissions</span></button>
                        <button mat-raised-button  (click)="editDialog(element)" matTooltip="Edit Info" permission="Users" [permissionTypes]="[PermissionType.ALL, PermissionType.EDIT]"><span style="color:black">Edit Info</span></button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <mat-paginator [pageSizeOptions]="[12,24,48,96,200]">
          </mat-paginator>
        </div>
      </div>
    </div>
  </div>
</div>

